import { render } from "./CustomDropdown.vue?vue&type=template&id=0770e75e&scoped=true&ts=true"
import script from "./CustomDropdown.vue?vue&type=script&lang=ts"
export * from "./CustomDropdown.vue?vue&type=script&lang=ts"

import "./CustomDropdown.vue?vue&type=style&index=0&id=0770e75e&scoped=true&lang=css"

import exportComponent from "/Users/angeloquijano/Git/IWARI/iwari-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0770e75e"]])

export default __exports__